export const Row = ({
  label,
  value,
  muted = false,
  strong = false,
}: {
  label: string
  value: string
  muted?: boolean
  strong?: boolean
}) => (
  <div
    className={
      strong
        ? 'flex justify-between border-t pt-1.5 font-medium'
        : 'flex justify-between'
    }
  >
    <dt className={muted ? 'text-muted-foreground' : undefined}>{label}</dt>
    <dd className="tabular-nums">{value}</dd>
  </div>
)
